import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ManageGamesComponent} from "./manage-games/manage-games.component";
import { AuthGuard } from 'src/app/shared/services/auth.guard';

const paths: string[] = ['game-grid','game-grid.html', 'game-details/:id', 'game-over/:id', 'prize-details/:game/:prize/:type'];
const routes: Routes = paths.map(path => ({ path, component: ManageGamesComponent, canActivate: [AuthGuard] }));

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ManageGamesRoutingModule {
}
